<div class="chennai-container">
  <!-- Header con botón de refresh -->
  <div class="header">
    <div>
      <h1>Chennai Projects</h1>
    </div>

    <button
      class="refresh-button"
      (click)="refreshData()"
      [disabled]="isRefreshing"
      [class.refreshing]="isRefreshing"
      title="Refresh data"
    >
      <span class="icon" [class.spinning]="isRefreshing">⟳</span>
      @if (!isRefreshing) {
        <span>Refresh</span>
      }
      @if (isRefreshing) {
        <span>Refreshing...</span>
      }
    </button>
  </div>

  @if (isInitialLoading) {
    <!-- Loading state (solo primera carga sin caché) -->
    <div class="loading-state">
      <div class="spinner"></div>
      <p>Loading projects...</p>
    </div>
  }

  @if (!isInitialLoading) {
    <!-- Tabla de datos -->
    <app-tabla [ec2Repositories]="demo"></app-tabla>
  }

  @if (!isInitialLoading && demo.length === 0) {
    <!-- Empty state -->
    <div class="empty-state">
      <p>No projects found</p>
      <button (click)="refreshData()">Try Again</button>
    </div>
  }
</div>
